var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiconServer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.1431 6.85715H2.85742V14.8571H29.1431V6.85715Z",
    stroke: "#A1A1A1",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2854 9.14285H25.1426",
    stroke: "#A1A1A1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2854 10.8571H25.1426",
    stroke: "#A1A1A1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2854 12.5714H25.1426",
    stroke: "#A1A1A1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5706 9.14285H23.4277",
    stroke: "#A1A1A1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5706 10.8571H23.4277",
    stroke: "#A1A1A1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5706 12.5714H23.4277",
    stroke: "#A1A1A1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8577 9.14285H21.7148",
    stroke: "#A1A1A1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8577 10.8571H21.7148",
    stroke: "#A1A1A1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8577 12.5714H21.7148",
    stroke: "#A1A1A1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M6.8577 12C7.48888 12 8.00056 11.4883 8.00056 10.8572C8.00056 10.226 7.48888 9.71429 6.8577 9.71429C6.22652 9.71429 5.71484 10.226 5.71484 10.8572C5.71484 11.4883 6.22652 12 6.8577 12Z",
    fill: "#73B8FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2854 12C10.9166 12 11.4283 11.4883 11.4283 10.8572C11.4283 10.226 10.9166 9.71429 10.2854 9.71429C9.65425 9.71429 9.14258 10.226 9.14258 10.8572C9.14258 11.4883 9.65425 12 10.2854 12Z",
    fill: "#94F6F6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1431 17.1429H2.85742V25.1429H29.1431V17.1429Z",
    stroke: "#A1A1A1",
    strokeWidth: 1.5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2854 19.4286H25.1426",
    stroke: "#A1A1A1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2854 21.1429H25.1426",
    stroke: "#A1A1A1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2854 22.8571H25.1426",
    stroke: "#A1A1A1"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5706 19.4286H23.4277",
    stroke: "#A1A1A1"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5706 21.1429H23.4277",
    stroke: "#A1A1A1"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5706 22.8571H23.4277",
    stroke: "#A1A1A1"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8577 19.4286H21.7148",
    stroke: "#A1A1A1"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8577 21.1429H21.7148",
    stroke: "#A1A1A1"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8577 22.8571H21.7148",
    stroke: "#A1A1A1"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M6.8577 22.2857C7.48888 22.2857 8.00056 21.774 8.00056 21.1429C8.00056 20.5117 7.48888 20 6.8577 20C6.22652 20 5.71484 20.5117 5.71484 21.1429C5.71484 21.774 6.22652 22.2857 6.8577 22.2857Z",
    fill: "#73B8FF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2854 22.2857C10.9166 22.2857 11.4283 21.774 11.4283 21.1429C11.4283 20.5117 10.9166 20 10.2854 20C9.65425 20 9.14258 20.5117 9.14258 21.1429C9.14258 21.774 9.65425 22.2857 10.2854 22.2857Z",
    fill: "#94F6F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiconServer);
export default __webpack_public_path__ + "static/media/dicon_server.c3da1df4c5be6b893a1040278f93e155.svg";
export { ForwardRef as ReactComponent };